export default "__VITE_ASSET__nZsjelgn__"